export class SignIn {
  constructor() {
    this.username = null;
    this.password = null;
  }
}

export class SignUp {
  constructor() {
    this.name = null;
    this.publicName = null;
    this.email = null;
    this.password = null;
    this.confirmPassword = null;
  }
}